import { useContext } from 'react'
import AuthContext from '../context/AuthProvider'

const useQuiosco = () => {
  return useContext(AuthContext)
}

export default useQuiosco